module.exports = __webpack_public_path__ + "img/mallaborreguera.e9cc0cf4.jpg";